import component from './CombiHousingSituation.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceComponentConfig,
  FormMultipleChoiceValueType,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';

export interface CombiHousingSituationStepContext extends AssistantStepContext {
  housingSituation: FormMultipleChoiceValueType;
}

const config: StepDefinition = {
  component,
  hideSkipMessage: () => true,
  fields: [
    {
      component: {
        options: [
          {
            value: 'ownHouse',
          },
          {
            value: 'planning',
          },
          {
            value: 'rent',
          },
        ],
        columns: 1,
        singleAnswer: true,
      } as FormMultipleChoiceComponentConfig,
      name: 'housingSituation',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.OBJECT,
    },
  ],
  id: StepId.COMBI_HOUSING_SITUATION,
  categoryId: StepCategoryId.COMBI,
};

export default config;
